CampoExtraFirmaDirectiva.$inject = [];

export default function CampoExtraFirmaDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'campoExtra': '=',
            'updateActive': '=',
            'claseRow': '@'
        },
        template: require('./campos-extra-firma.html'),
        controller: 'CamposExtraFirmaCtrl as campExtFirma',
        bindToController: true
    }
}